import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useSuperAdminAuth } from '../../contexts/SuperAdminAuthContext';

const SuperAdminLayout = ({ children }) => {
  const { user, logout } = useSuperAdminAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="super-admin-layout">
      <header className="admin-header">
        <div className="header-left">
          <h1>SportsTMS Platform</h1>
          <span className="admin-badge">Super Admin</span>
        </div>
        <div className="header-right">
          <span>Welcome, {user?.name}</span>
          <button onClick={handleLogout} className="btn-secondary">
            <i className="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </header>

      <nav className="admin-nav">
        <Link to="/dashboard" className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
          <i className="fas fa-tachometer-alt"></i>
          Dashboard
        </Link>
        <Link to="/clients" className={`nav-item ${isActive('/clients') ? 'active' : ''}`}>
          <i className="fas fa-users"></i>
          Client Management
        </Link>
        <Link to="/domains" className={`nav-item ${isActive('/domains') ? 'active' : ''}`}>
          <i className="fas fa-globe"></i>
          Domain Management
        </Link>
      </nav>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default SuperAdminLayout;